import styles from "../../../../styles/pages/DocumentationPage/components/DocTabs/Postback.module.css"
import React, { useContext } from 'react'
import { ThemeContext } from "../../../../context/ThemeContext"

export const Postback = () => {
  const { theme } = useContext(ThemeContext);

  const wrapperClass = `${styles.wrapper} ${theme === 'dark' ? styles.darkWrapper : ''}`;
  const textClass = `${styles.text} ${theme === 'dark' ? styles.darkText : ''}`;
  const subHeadingClass = `${styles.subHeading} ${theme === 'dark' ? styles.darkSubHeading : ''}`;

  return (
    <div className={wrapperClass}>
      <p className={textClass}>
        Система поддерживает 3 типа постбеков: Status Postback, FTD Postback, RevShare Postback
      </p>
      <p className={textClass}>
        Для подключения любого из вышеуказанных постбеков, обращайтесь к администратору и предоставьте url для отправления соответствующего постбека.
      </p>

      <div className={styles.container}>
        <h3 className={subHeadingClass}>Пример Status Postback:</h3>
        <pre className={styles.code}>
          {`{
    "Last": 110M,
    "Status": "No Answer"
}`}
        </pre>
      </div>

      <div className={styles.container}>
        <h3 className={subHeadingClass}>Пример FTD Postback:</h3>
        <pre className={styles.code}>
          {`{
    "Last": 110M,
    "Ftd": true
}`}
        </pre>
      </div>

      <div className={styles.container}>
        <h3 className={subHeadingClass}>Пример RevShare Postback:</h3>
        <pre className={styles.code}>
          {`{
    "Last": 110M,
    "Assets": 30%
}`}
        </pre>
      </div>

    </div>
  )
}